import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { InfoCard } from 'core/components';
import { PhoneNumber } from 'core/elements';
import { getAddressToDisplay, getValue } from 'core/utils';
import {
  ContactGroupAddressType,
  UpdateQuoteAddress,
} from 'quotes/components/CustomerQuoteDetails/Tabs/CustomerQuoteBaseInformation';
import { QuoteEntityType } from 'quotes/enums';
import { ICustomerQuote } from 'quotes/types';

import { SectionWarning } from './SectionWarning';
import { getInactiveShipToProjectLinkMessage } from './utils';

interface IProps {
  quote: ICustomerQuote;
  updateQuote: (updatedQuote?: ICustomerQuote) => void;
  entityType?: QuoteEntityType;
  isEditable?: boolean;
}

export const ShipToInfo = ({
  quote,
  updateQuote,
  entityType = QuoteEntityType.QUOTE,
  isEditable = true,
}: IProps) => {
  const [isEditOpen, setIsEditOpen] = useState<boolean>(false);

  const { t } = useTranslation();

  const inactiveProjectLinkMessage = getInactiveShipToProjectLinkMessage(quote, entityType);

  const handleOnClose = (updatedQuote?: ICustomerQuote) => {
    setIsEditOpen(false);
    updateQuote(updatedQuote);
  };

  return (
    <>
      <InfoCard
        title={t('titleShipTo')}
        items={[
          {
            label: getValue(quote, 'shipToAddress.contactCompanyName', '') as string,
            value: [
              getValue(quote, 'shipToAddress.contactName'),
              <PhoneNumber
                key="shipToAddressContactPhone"
                phone={getValue(quote, 'shipToAddress.contactPhone') as string}
              />,
            ],
          },
          {
            label: getValue(quote, 'shipToAddress.name') as string,
            value: getAddressToDisplay(quote?.shipToAddress),
            extra: inactiveProjectLinkMessage ? (
              <SectionWarning message={inactiveProjectLinkMessage} />
            ) : undefined,
          },
        ]}
        onEdit={() => setIsEditOpen(true)}
        isEditable={isEditable}
      />

      <UpdateQuoteAddress
        isOpen={isEditOpen}
        quote={quote}
        entityType={entityType}
        onClose={handleOnClose}
        addressType={ContactGroupAddressType.SHIP_TO}
        hasCreateNewLocation
        hasCreateNewContact
      />
    </>
  );
};
